"use client";

import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";
import ImageComponent from "@/src/components/common/ImageComponent";
import "swiper/css";
import { LeftArrowSVG, RightArrowSVG } from "@/src/ui/AllSVG";
import { Button } from "@heroui/react";

interface ProductImageSliderProps {
    images: string[];
    alt: string;
    objectCover?: boolean;
}

export default function ProductImageSlider({ images, alt, objectCover = false }: ProductImageSliderProps) {
    const swiperRef = useRef<SwiperType | null>(null);

    const hasMultiple = (images?.length ?? 0) > 1;

    return (
        <>
            <div className="relative w-full h-full">
                <Swiper
                    modules={[Pagination]}
                    onSwiper={(swiper) => { swiperRef.current = swiper; }}
                    pagination={hasMultiple ? {
                        clickable: true,
                        el: ".pqs-dots",
                        renderBullet: (_, cls) => `<button class="${cls}"></button>`,
                        bulletClass: "w-3 h-3 rounded-full transition-colors bg-white/25 cursor-pointer",
                        bulletActiveClass: "!bg-white",
                    } : false}
                    loop={hasMultiple}
                    className="w-full h-full cursor-grab"
                >
                    {images?.map((src, index) => (
                        <SwiperSlide key={index} className="h-full!">
                            <ImageComponent src={src} alt={alt} object_cover={objectCover} priority={index === 0} />
                        </SwiperSlide>
                    ))}
                </Swiper>
    
                {hasMultiple && (
                    <>
                        <Button
                            onClick={() => swiperRef.current?.slidePrev()}
                            className="icon_only_btn absolute left-3 top-1/2 -translate-y-1/2 z-10"
                            aria-label="Previous image"
                        >
                            <RightArrowSVG />
                        </Button>
                        <Button
                            onClick={() => swiperRef.current?.slideNext()}
                            className="icon_only_btn absolute right-3 top-1/2 -translate-y-1/2 z-10"
                            aria-label="Next image"
                        >
                            <LeftArrowSVG />
                        </Button>
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10">
                            <div className="pqs-dots flex items-center gap-1.5" />
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
